import { ShippingPartner } from "@deliverr/billing-pricer-client/lib/shared/ShippingPartner";
import { FulfillmentOrderTag } from "@deliverr/fulfillment-order-client";
import { OrderSummary } from "common/clients/orders/OrderSummary";
import { BillingOrderType } from "@deliverr/billing-types";

export const getBillingOrderType = (order: OrderSummary): BillingOrderType => {
  const tags = order.tags || [];

  // Using as any to avoid type errors due to mismatch between FulfillmentOrderTag and OrderTag
  if (tags.includes(FulfillmentOrderTag.USE_ONLY_SELLER_CARRIER_ACCOUNTS as any)) {
    return BillingOrderType.THIRD_PARTY_DROPSHIP;
  }

  if (
    tags.includes(FulfillmentOrderTag.DROPSHIP_ORDER as any) &&
    tags.includes(FulfillmentOrderTag.USE_ONLY_RETAILER_CARRIER_ACCOUNTS as any)
  ) {
    return BillingOrderType.RETAILER_DROPSHIP;
  }

  return BillingOrderType.FLEXPORT_SHIPPING;
};

export const isDropshipOrder = (orderType: BillingOrderType): boolean => {
  return orderType === BillingOrderType.THIRD_PARTY_DROPSHIP || orderType === BillingOrderType.RETAILER_DROPSHIP;
};

export const getShippingPartnerFromOrderType = (orderType: BillingOrderType): ShippingPartner => {
  if (orderType === BillingOrderType.THIRD_PARTY_DROPSHIP) {
    return ShippingPartner.Seller;
  }

  if (orderType === BillingOrderType.RETAILER_DROPSHIP) {
    return ShippingPartner.Retailer;
  }

  return ShippingPartner.Flexport;
};
